import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  ExpandMore as ExpandMoreIcon,
  BorderColorTwoTone as BorderColorTwoToneIcon,
} from "@mui/icons-material";
import { useParams } from "react-router-dom";
import "./preview.css";
import { convertDate } from "../../Helper";
import { getRequestGlobal } from "../../../API/global";
import { getRequest } from "../../../API/IP";
import { GLOBAL_URL } from "../../../API/global";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const Preview = ({ formData, setActiveStep }) => {
  // State variables
  const [language, setLanguage] = useState({});
  const [genre, setGenre] = useState({});
  const [preEpisodeData, setPreEpisodeData] = useState([]);
  const [coproData, setCoproData] = useState([]);
  const [streemOutData, setStreemOutData] = useState([]);
  const [screeningData, setScreeningData] = useState([]);
  const [broardcastData, setBroardcastData] = useState([]);
  const [Competition, setCompetition] = useState([]);
  const [createrDetails, setCreaterDetails] = useState([]);
  const [directorDetails, setDirectorDetails] = useState([]);
  const [countryId, setCountryId] = useState({});
  // Get ID from URL parameters
  const { id = null } = useParams();

  useEffect(() => {
    const loadData = async () => {
      const coproResponse = await getRequest(`ott/${id}/coproducer`);
      const coproData = coproResponse.data;
      setCoproData(coproData);

      const episodeResponse = await getRequest(`ott/${id}/episode`);
      const episodeData = episodeResponse.data;
      setPreEpisodeData(episodeData);

      const languageResponse = await getRequestGlobal("language_list", {});
      setLanguage(languageResponse.data);

      const genreResponse = await getRequestGlobal("genre", {});
      setGenre(genreResponse.data);

      const country = await getRequestGlobal("country", {});

      setCountryId(country.data);

      const streemOut = await getRequest(`ott/${id}/streamed-country`);
      setStreemOutData(streemOut.data);

      const screening = await getRequest(`ott/${id}/threatrical-screening`);
      setScreeningData(screening.data);

      const broardcast = await getRequest(`ott/${id}/broardcast`);
      setBroardcastData(broardcast.data);

      const competition = await getRequest(
        `ott/${id}/international-competition`
      );
      setCompetition(competition.data);

      const createrDetails = await getRequest(`ott/${id}/creator/type/1`);
      setCreaterDetails(createrDetails.data);

      const directorDetails = await getRequest(`ott/${id}/creator/type/2`);
      setDirectorDetails(directorDetails.data);
    };

    loadData();
  }, [id]);

  // Handler to redirect to a specific step
  const handleRedirectStep = (value) => setActiveStep(value);

  const [expanded, setExpanded] = React.useState("panel1");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const toRoman = (num) => {
    const romanNumerals = [
      ["XL", 40],
      ["X", 10],
      ["IX", 9],
      ["V", 5],
      ["IV", 4],
      ["I", 1],
    ];

    let roman = "";
    for (let [letter, value] of romanNumerals) {
      while (num >= value) {
        roman += letter;
        num -= value;
      }
    }
    return roman;
  };

  return (
    <div className="container mt-5">
      {/* Accordion for Web Series Details */}
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <button
            onClick={() => handleRedirectStep(0)}
            style={{
              background: "transparent",
              border: "none",
              marginRight: "20px",
              color: "#1c5768",
            }}
          >
            <BorderColorTwoToneIcon />
          </button>
          Details of Web Series
        </AccordionSummary>
        <AccordionDetails>
          <Container maxWidth="lg">
            <p className="m-0">
              <span className="titleoffield-view-out">
                1. Details of Web Series <span className="text-danger"> *</span>
              </span>
            </p>

            <div className="row">
              <div className="col-md-6">
                <p>
                  <span className="">
                    (a) Title of Web Series (in the original language of
                    release) :{" "}
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">{formData.title} </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <p>
                  <span className="">
                    (b) English translation of the title :{" "}
                  </span>
                  <span className="inputoffield"> </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">
                    {formData.title_in_english}{" "}
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <p>
                  <span className="">(c) Genre </span>
                  <span className="inputoffield"> : </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">
                    {genre[formData.genre_id] || ""}
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
              {formData.genre_id == 25 ? (
                <>
                  <div className="col-md-6">
                    <p>
                      <span className="">(c.i) Other Genre : </span>
                      <span className="inputoffield"> </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.other_genre}{" "}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>

            <div className="row">
              <div className="col-md-6">
                <p>
                  <span className="">
                    (d) Language in which the Web Series was originally released
                    :{" "}
                  </span>
                  <span className="inputoffield"> </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">
                    {language[formData.language_id] || ""}
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>

              {formData.language_id == 20 ? (
                <>
                  <div className="col-md-6">
                    <p>
                      <span className="">(d.i) Other language : </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {" "}
                        {formData.other_language}{" "}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>

            <div className="row">
              <div className="col-md-6">
                <p>
                  <span className="">
                    (e) Whether the series is subtitled in English :{" "}
                  </span>
                  <span className="inputoffield"> </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">
                    {formData.is_subtitle_language_eng === 1 ? "Yes" : "No"}{" "}
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <p>
                  <span className="">
                    (f) Other languages in which subtitles are available (if
                    any)
                  </span>
                  <span className="inputoffield"> :</span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">
                    {" "}
                    {language[formData.subtitle_other_language] || ""}
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
              {formData.subtitle_other_language == 20 ? (
                <>
                  <div className="col-md-6">
                    <p>
                      <span className="">(f.i) Other Subtitle Langauge : </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.other_subtitle_language}{" "}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>

            <div></div>
          </Container>
        </AccordionDetails>
      </Accordion>

      {/* Accordion for Season & Episodes Details */}
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <button
            onClick={() => handleRedirectStep(1)}
            style={{
              background: "transparent",
              border: "none",
              marginRight: "20px",
              color: "#1c5768",
            }}
          >
            <BorderColorTwoToneIcon />
          </button>
          Details of Season & Episodes
        </AccordionSummary>
        <AccordionDetails>
          <Container maxWidth="lg">
            <p className="m-0">
              <span className="titleoffield-view-out">
                2. Details Of Season & Episodes{" "}
                <span className="text-danger"> *</span>
              </span>
            </p>
            <div className="row">
              <div className="col-md-6">
                <p>
                  <span className="">(a) Season : </span>
                  <span className="inputoffield"> </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">{formData.season} </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="">(b) Total Runtime (in minutes) :</span>
                  <span className="inputoffield"> </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">{formData.runtime}</span>
                  <span className="inputoffield"></span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="">(c) Number of episodes : </span>
                  <span className="inputoffield"> </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">
                    {formData.number_of_episode}{" "}
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="">
                    (d) Whether the duration of each episode of the season is 20
                    mins or more:{" "}
                  </span>
                  <span className="inputoffield"> </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="">
                    {formData.is_long_duration_timing ? "Yes" : "No"}
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="">(e) Release date of the season : </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">
                    {" "}
                    {convertDate(formData.release_date)}
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>

              <div className="col-md-6">
                <p>
                  <span className="">
                    {" "}
                    (f) Whether all the episodes were released on the same date?
                    :{" "}
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">
                    {formData.is_episode_have_same_date ? "Yes" : "No"}{" "}
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>

              {formData.is_episode_have_same_date ? (
                <></>
              ) : (
                <>
                  <p className="m-0 mt-2">
                    <span className="titleoffield-view-out">
                      (g) Episodes and Release date
                    </span>
                  </p>

                  <div className="col-md-12 mt-2">
                    <>
                      <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              {/* <TableCell align="center">Sr. No.</TableCell> */}
                              <TableCell align="center">
                                (i) Episode Number
                              </TableCell>
                              <TableCell align="center">
                                (ii) Release date of the episode(s)
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {preEpisodeData.map((row, index) => (
                              <TableRow
                                key={row.name}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                {/* <TableCell align="center">
                                  ({toRoman(index + 1)})
                                </TableCell> */}
                                <TableCell align="center">
                                  {row.episode_number}
                                </TableCell>
                                <TableCell align="center">
                                  {row.release_date}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  </div>
                </>
              )}
            </div>
          </Container>
        </AccordionDetails>
      </Accordion>

      {/* Accordion for Details Of Production */}
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel3-header"
        >
          <button
            onClick={() => handleRedirectStep(2)}
            style={{
              background: "transparent",
              border: "none",
              marginRight: "20px",
              color: "#1c5768",
            }}
          >
            <BorderColorTwoToneIcon />
          </button>
          Details of Producer(s)
        </AccordionSummary>
        <AccordionDetails>
          <Container maxWidth="lg">
            <p className="m-0">
              <span className="titleoffield-view-out">
                3. Details Of Producer(s){" "}
                <span className="text-danger"> *</span>
              </span>
            </p>
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="">
                        (a) Whether the Web Series is a co-production :{" "}
                      </span>
                      <span className="inputoffield"> </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.has_coproduction ? "Yes" : "No"}{" "}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="">(b) Producer Details : </span>
                      <span className="inputoffield"> </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.producer_details}{" "}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                </div>

                {formData.has_coproduction == 1 && (
                  <>
                    <div className="row">
                      {coproData.map((item, index) => (
                        <div className="col-md-12">
                          <div
                            className="card"
                            style={{
                              width: "100%",
                              marginTop: "10px",
                              marginRight: "15px",
                            }}
                          >
                            <div className="card-body row">
                              <p>({toRoman(index + 1)}) Producer Details</p>
                              <Container>
                                <div className="row">
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (c) Production Type :{" "}
                                      </span>
                                      <span className="inputoffield"></span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="titleoffield"> </span>
                                      <span className="inputoffield">
                                        {" "}
                                        &nbsp;
                                        {item.type == 1
                                          ? "OTT"
                                          : item.type == 2
                                            ? "Production House"
                                            : "Individual Producer"}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">(i) Name :</span>
                                      <span className="inputoffield"></span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="inputoffield">
                                        {item.name}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>

                                  <div className="col-md-6">
                                    <p>
                                      <span className="">(ii) Address :</span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="inputoffield">
                                        {item.address}
                                      </span>
                                      <span className="inputoffield"></span>
                                    </p>
                                  </div>

                                  <div className="col-md-6">
                                    <p>
                                      <span className="">(iii) Phone :</span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="inputoffield">
                                        {item.phone}
                                      </span>
                                      <span className="inputoffield"></span>
                                    </p>
                                  </div>

                                  <div className="col-md-6">
                                    <p>
                                      <span className="">(iv) E-mail :</span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="inputoffield">
                                        {item.email}
                                      </span>
                                      <span className="inputoffield"></span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (v) Website (Optional) :
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="inputoffield">
                                        {item.website}
                                      </span>
                                      <span className="inputoffield"></span>
                                    </p>
                                  </div>

                                  {item.type == 1 ? (
                                    <>
                                      <div className="col-md-6">
                                        <p>
                                          (vi) Whether the OTT Platform has
                                          furnished information under Rule 18 of
                                          IT Rules, 2021 to the Ministry of
                                          Information and Broadcasting,
                                          Government of India :
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="inputoffield">
                                            {item.is_follow_it_rules
                                              ? "Yes"
                                              : "No"}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vii) Whether the Web Series is its
                                            original production. :{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="inputoffield">
                                            {item.is_original_production
                                              ? "Yes"
                                              : "No"}{" "}
                                          </span>
                                          <span className="inputoffield"></span>
                                        </p>
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  {item.type == 2 && item.is_registered == 1 ? (
                                    <>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vi) Whether the Production House is
                                            incorporated/registered in India:{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="inputoffield">
                                            {item.is_registered ? "Yes" : "No"}{" "}
                                          </span>
                                          <span className="inputoffield"></span>
                                        </p>
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  {item.type == 2 &&
                                    item.is_registered === 0 ? (
                                    <>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vi) Whether the Production House is
                                            incorporated/registered in India:{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="inputoffield">
                                            {item.is_registered ? "Yes" : "No"}{" "}
                                          </span>
                                          <span className="inputoffield"></span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vi.i) Please mention the country:{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="inputoffield">
                                            {item.nationality}
                                          </span>
                                          <span className="inputoffield"></span>
                                        </p>
                                      </div>
                                      {/* <p>(g) Please mention the country : {item.nationality}</p> */}
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vi.ii) Upload proof of the PDF:{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            {item?.documents?.[0]?.name}{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  {item.type == 3 &&
                                    item.is_residing_in_country == 1 ? (
                                    <>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vi) Whether the Individual Producer
                                            is normally working and residing in
                                            India:{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            {item.is_residing_in_country
                                              ? "Yes"
                                              : "No"}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  {item.type == 3 &&
                                    item.is_residing_in_country === 0 ? (
                                    <>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            (vi.i) Whether the individual
                                            Producer is normally working and
                                            residing in India:{" "}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-md-6">
                                        <p>
                                          <span className="">
                                            {item.is_residing_in_country
                                              ? "Yes"
                                              : "No"}
                                          </span>
                                          <span className="inputoffield">
                                            {" "}
                                          </span>
                                        </p>
                                      </div>
                                      <p>
                                        (i) Please mention the country :{" "}
                                        {item.nationality}
                                      </p>
                                    </>
                                  ) : (
                                    <></>
                                  )}

                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (vi.i) Upload proof of the
                                        incorporation/registration/Individual in
                                        India:{" "}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        {item?.documents?.[0]?.name}{" "}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                </div>
                              </Container>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="col-md-12 text-danger">
                      <p>
                        Note:&nbsp;The name of the OTT
                        Platform/producer(s)/production House(s)/co-producer(s)
                        will be credited as declared in the application form. No
                        request for the change of names would be entertained at
                        any stage.
                      </p>
                    </div>
                  </>
                )}

                {!formData.has_coproduction && (
                  <>
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <p>
                              <span className="">(c) Production Type : </span>
                              <span className="inputoffield"></span>
                            </p>
                          </div>
                          <div className="col-md-6">
                            <p>
                              <span className="titleoffield"> </span>
                              <span className="inputoffield">
                                {" "}
                                &nbsp;
                                {formData.coproducer_type == 1
                                  ? "OTT"
                                  : formData.coproducer_type == 2
                                    ? "Production House"
                                    : "Individual Producer"}
                              </span>
                            </p>
                          </div>
                          <Container>
                            <div className="row">
                              <div className="col-md-6">
                                <p>
                                  <span className="">(i) Name :</span>
                                  <span className="inputoffield"></span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="inputoffield">
                                    {formData.coproducer_name}
                                  </span>
                                  <span className="inputoffield"> </span>
                                </p>
                              </div>

                              <div className="col-md-6">
                                <p>
                                  <span className="">(ii) Address :</span>
                                  <span className="inputoffield"> </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="inputoffield">
                                    {formData.coproducer_address}
                                  </span>
                                  <span className="inputoffield"></span>
                                </p>
                              </div>

                              <div className="col-md-6">
                                <p>
                                  <span className="">(iii) Phone :</span>
                                  <span className="inputoffield"> </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="inputoffield">
                                    {formData.coproducer_phone}
                                  </span>
                                  <span className="inputoffield"></span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="">(iv) E-mail :</span>
                                  <span className="inputoffield"> </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="inputoffield">
                                    {formData.coproducer_email}
                                  </span>
                                  <span className="inputoffield"></span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="">
                                    (v) Website (Optional) :
                                  </span>
                                  <span className="inputoffield"> </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="inputoffield">
                                    {formData.coproducer_website}
                                  </span>
                                  <span className="inputoffield"></span>
                                </p>
                              </div>
                              {formData.coproducer_type == 1 ? (
                                <>
                                  <div className="col-md-6">
                                    <p>
                                      (vi) The OTT platform must have furnished
                                      information to the Ministry in
                                      accordancwith Rule 18 of the IT Rules,
                                      2021:
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="inputoffield">
                                        {formData.coproducer_is_follow_it_rules
                                          ? "Yes"
                                          : "No"}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (vii) Whether the Web Series is its
                                        original production.:{" "}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="inputoffield">
                                        {formData.coproducer_is_original_production
                                          ? "Yes"
                                          : "No"}{" "}
                                      </span>
                                      <span className="inputoffield"></span>
                                    </p>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}

                              {formData.coproducer_type == 2 &&
                                formData.coproducer_is_registered == 1 ? (
                                <>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (vi) Whether the Production House is
                                        incorporated/registered in India:{" "}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="inputoffield">
                                        {formData.coproducer_is_registered
                                          ? "Yes"
                                          : "No"}{" "}
                                      </span>
                                      <span className="inputoffield"></span>
                                    </p>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}

                              {formData.coproducer_type == 2 &&
                                formData.coproducer_is_registered === 0 ? (
                                <>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (vi) Whether the Production House is
                                        incorporated/registered in India:{" "}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="inputoffield">
                                        {formData.coproducer_is_registered
                                          ? "Yes"
                                          : "No"}{" "}
                                      </span>
                                      <span className="inputoffield"></span>
                                    </p>
                                  </div>

                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (vi.i) Please mention the country :
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="inputoffield">
                                        {formData.nationality}
                                      </span>
                                      <span className="inputoffield"></span>
                                    </p>
                                  </div>
                                  {/* <p>(g) Nationality  : {formData.nationality}</p> */}
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (vi.ii) Upload proof of the PDF :{" "}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        {formData?.documentData?.[7]?.name}{" "}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                              {formData.coproducer_type == 3 &&
                                formData.coproducer_is_residing_in_country ==
                                1 ? (
                                <>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (vi) Whether the Individual Producer is
                                        normally working and residing in India:{" "}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        {formData.coproducer_is_residing_in_country
                                          ? "Yes"
                                          : "No"}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                              {formData.coproducer_type == 3 &&
                                formData.coproducer_is_residing_in_country ==
                                0 ? (
                                <>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (vi) Whether the Individual Producer is
                                        normally working and residing in India:{" "}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        {formData.coproducer_is_residing_in_country
                                          ? "Yes"
                                          : "No"}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        (vi.i) Please mention the country :
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      <span className="">
                                        {formData.nationality}
                                      </span>
                                      <span className="inputoffield"> </span>
                                    </p>
                                  </div>
                                  {/* <p>
                                (g) Nationality asasaasas :{" "}
                                  <b>{formData.nationality}</b>
                                </p> */}
                                </>
                              ) : (
                                <></>
                              )}
                              <div className="col-md-6">
                                <p>
                                  <span className="">
                                    (vi.i) Upload proof of the
                                    incorporation/registration/Individual in
                                    India:{" "}
                                  </span>
                                  <span className="inputoffield"> </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="">
                                    {formData?.documentData?.[5]?.name}{" "}
                                  </span>
                                  <span className="inputoffield"> </span>
                                </p>
                              </div>
                            </div>
                          </Container>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 text-danger mt-2">
                      <p>
                        Note :&nbsp;The name of the OTT
                        Platform/producer(s)/production House(s)/co-producer(s)
                        will be credited as declared in the application form. No
                        request for the change of names would be entertained at
                        any stage.
                      </p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </Container>
        </AccordionDetails>
      </Accordion>

      {/* Accordion for OTT - Platform */}
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <button
            onClick={() => handleRedirectStep(3)}
            style={{
              background: "transparent",
              border: "none",
              marginRight: "20px",
              color: "#1c5768",
            }}
          >
            <BorderColorTwoToneIcon />
          </button>
          Details of Streaming OTT Platform
        </AccordionSummary>
        <AccordionDetails>
          <Container maxWidth="lg">
            <p className="m-0">
              <span className="titleoffield-view-out">
                4. Details Of Streaming OTT Platform{" "}
                <span className="text-danger"> *</span>
              </span>
            </p>
            <div className="row">
              <div className="col-md-6">
                <p>
                  <span className="">
                    (a) Name of the OTT Platform where the Web Series was
                    originally released :{" "}
                  </span>
                  <span className="inputoffield"> </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">
                    {formData.ott_released_platform}{" "}
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="">
                    (b) Other OTT platform(s) on which the Web Series is
                    currently available, if any :{" "}
                  </span>
                  <span className="inputoffield"> </span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">
                    {formData.is_other_released_platform_available
                      ? "Yes"
                      : "No"}{" "}
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>

              {formData.is_other_released_platform_available ? (
                <>
                  <div className="col-md-6">
                    <p>
                      <span className="">Other OTT Platform : </span>
                      <span className="inputoffield"> </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.other_released_platform_available}{" "}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                </>
              ) : (
                <></>
              )}

              {/* <h6 style={{ textAlign: 'left', color: 'gray' }} className='mt-2'>6. Other Information</h6> */}
              <h6 className="m-0 mt-3">
                <span className="titleoffield-view-out">
                  5. Other Information <span className="text-danger"> *</span>
                </span>
              </h6>

              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="">
                        (a) Whether the Web Series has been streamed outside
                        India :{" "}
                      </span>
                      <span className="inputoffield"> </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.is_released_other_country ? "Yes" : "No"}{" "}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                </div>

                {formData.is_released_other_country &&
                  streemOutData.length > 0 ? (
                  <>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            {/* <TableCell align="center"> Sr No.</TableCell> */}
                            <TableCell align="center">
                              {" "}
                              (i) Name of Country
                            </TableCell>
                            <TableCell align="center">
                              {" "}
                              (ii) Name of the OTT Platform
                            </TableCell>
                            <TableCell align="center">
                              {" "}
                              (iii) Date of Release
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {streemOutData.map((row, index) => (
                            <TableRow
                              key={row.name}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              {/* <TableCell align="center">
                                {" "}
                                ({toRoman(index + 1)})
                              </TableCell> */}
                              <TableCell align="center">
                                {" "}
                                {countryId[row.country_id] || ""}
                              </TableCell>
                              <TableCell align="center">
                                {row.platform_name}
                              </TableCell>
                              <TableCell align="center">
                                {row.release_date}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                ) : (
                  <></>
                )}
              </div>

              <div className="col-md-12 mt-3">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="">
                        (b) Whether the Web Series has been presented for
                        festival/theatrical screening :{" "}
                      </span>
                      <span className="inputoffield"> </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.is_thretrical_screening ? "Yes" : "No"}{" "}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                </div>

                {formData.is_thretrical_screening &&
                  screeningData.length > 0 ? (
                  <>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            {/* <TableCell align="center">Sr. No.</TableCell> */}
                            <TableCell align="center">
                              (i) Name of the festival/Screening
                            </TableCell>
                            <TableCell align="center">
                              (ii) Date of the Festival/Screening
                            </TableCell>
                            <TableCell align="center">
                              {" "}
                              (iii) Address of the Festival/Screening
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {screeningData.map((row, index) => (
                            <TableRow
                              key={row.name}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              {/* <TableCell align="center">
                                ({toRoman(index + 1)})
                              </TableCell> */}
                              <TableCell align="center">
                                {row.festival_name}
                              </TableCell>
                              <TableCell align="center">
                                {row.date_of_festival}
                              </TableCell>
                              <TableCell align="center">
                                {row.address}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                ) : (
                  <></>
                )}
              </div>

              <div className="col-md-12 mt-3">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="">
                        (c) Whether Web Series has been streamed/broadcasted on
                        the Internet/TV or other media :{" "}
                      </span>
                      <span className="inputoffield"> </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.is_streamed_other_media ? "Yes" : "No"}{" "}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                </div>

                {formData.is_streamed_other_media &&
                  broardcastData.length > 0 ? (
                  <>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            {/* <TableCell align="center">Sr. No. </TableCell> */}
                            <TableCell align="center">
                              (i) Date of the Streaming
                            </TableCell>
                            <TableCell align="center">
                              (ii) Name of the platform
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {broardcastData.map((row, index) => (
                            <TableRow
                              key={row.name}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              {/* <TableCell align="center">
                                ({toRoman(index + 1)})
                              </TableCell> */}
                              <TableCell align="center">
                                {row.stream_date}
                              </TableCell>
                              <TableCell align="center">
                                {row.platform_name}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                ) : (
                  <></>
                )}
              </div>

              <div className="col-md-12 mt-3">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="">
                        (d) Whether Web Series has participated in any
                        International Competition :{" "}
                      </span>
                      <span className="inputoffield"> </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.is_international_competition ? "Yes" : "No"}{" "}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                </div>

                {formData.is_international_competition &&
                  Competition.length > 0 ? (
                  <>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            {/* <TableCell align="center"> Sr. No</TableCell> */}
                            <TableCell align="center">
                              {" "}
                              (i) Name of the Competition
                            </TableCell>
                            <TableCell align="center">
                              (ii) Date of the Competition
                            </TableCell>
                            <TableCell align="center">
                              {" "}
                              (iii) Details of the Awards won(if any)
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Competition.map((row, index) => (
                            <TableRow
                              key={row.name}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              {/* <TableCell align="center">
                                ({toRoman(index + 1)})
                              </TableCell> */}
                              <TableCell align="center">
                                {row.competition_name}
                              </TableCell>
                              <TableCell align="center">
                                {row.competition_date}
                              </TableCell>
                              <TableCell align="center">
                                {row.details}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </Container>
        </AccordionDetails>
      </Accordion>

      {/* Accordion for Director(s)/Creator's Details */}
      <Accordion
        expanded={expanded === "panel5"}
        onChange={handleChange("panel5")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <button
            onClick={() => handleRedirectStep(4)}
            style={{
              background: "transparent",
              border: "none",
              marginRight: "20px",
              color: "#1c5768",
            }}
          >
            <BorderColorTwoToneIcon />
          </button>
          Director(s)/Creator(s) Details
        </AccordionSummary>
        <AccordionDetails>
          <Container maxWidth="lg">
            <p className="m-0">
              <span className="titleoffield-view-out">
                6. Director(s)/Creator(s) Details{" "}
                <span className="text-danger"> *</span>
              </span>
            </p>
            <div className="row">
              {/* <h5 style={{ textAlign: 'left', color: 'black', padding: '10px' }}>(a) Creator(s) Details</h5> */}
              <p className="m-0 mt-4">
                <span className="titleoffield-view-out">
                  (a) Director(s) Details
                </span>
              </p>
              <div className="col-md-12 mt-2">
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        {/* <TableCell align="center">(i) Sr No.</TableCell> */}
                        <TableCell align="center">(i) Name</TableCell>
                        <TableCell align="center">(ii) Nationality</TableCell>
                        <TableCell align="center">(iii) Phone</TableCell>
                        <TableCell align="center">(iv) E-mail</TableCell>
                        <TableCell align="center">(v) Website</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {directorDetails.map((row, index) => (
                        <TableRow
                          key={row.name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          {/* <TableCell align="center">
                            ({toRoman(index + 1)})
                          </TableCell> */}
                          <TableCell align="center">{row.name}</TableCell>
                          <TableCell align="center">
                            {countryId[row.country_id] || ""}
                          </TableCell>
                          <TableCell align="center">{row.phone}</TableCell>
                          <TableCell align="center">{row.email}</TableCell>
                          <TableCell align="center">{row.website}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <p className="m-0 mt-4">
                <span className="titleoffield-view-out">
                  (b) Creator(s) Details
                </span>
              </p>

              <div className="col-md-12 mt-2">
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        {/* <TableCell align="center">(i) Sr No.</TableCell> */}
                        <TableCell align="center">(i) Name</TableCell>
                        <TableCell align="center">(ii) Nationality</TableCell>
                        <TableCell align="center">(iii) Phone</TableCell>
                        <TableCell align="center">(iv) E-mail</TableCell>
                        <TableCell align="center">(v) Website</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {createrDetails.map((row, index) => (
                        <TableRow
                          key={row.name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          {/* <TableCell align="center">
                            ({toRoman(index + 1)})
                          </TableCell> */}
                          <TableCell align="center">{row.name}</TableCell>
                          <TableCell align="center">
                            {countryId[row.country_id] || ""}
                          </TableCell>
                          <TableCell align="center">{row.phone}</TableCell>
                          <TableCell align="center">{row.email}</TableCell>
                          <TableCell align="center">{row.website}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              {/* <h5 style={{ textAlign: 'left', color: 'black', padding: '10px' }} className='mt-3'>(b) Director(s) Details</h5> */}

              {/* <h5 style={{ textAlign: 'left', color: 'black', padding: '10px' }} className='mt-3'>8. Other Details</h5> */}

              <p className="text-danger mt-4">
                NOTE: Name of the Director(s)/ Creator(s) will be credited as
                declared in the application form. No request for the change of
                name would be entertained at any stage.
              </p>

              <p
                // className="m-0"
                className="mt-2"
                style={{ marginTop: "80px" }}
              >
                <span className="titleoffield-view-out mt-4">
                  7. Other Details <span className="text-danger"> *</span>
                </span>
              </p>
              <div className="col-md-12 mt-">
                <div className="row">
                  <div className="col-md-6">
                    <p>
                      <span className="">(i) Story Writer : </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.story_writer}{" "}
                      </span>
                      <span className="inputoffield"> </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="">(ii) Screenplay Writer : </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.screening_writer}{" "}
                      </span>
                      <span className="inputoffield"> </span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="">(iii) Director of Photography : </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.director_of_photography}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="">(iv) Editor : </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">{formData.editior} </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="">(v) Art Director : </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.art_director}{" "}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="">(vi) Costume Designer : </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.costume_director}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="">(vii) Director of Music : </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.music_director}{" "}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="">(viii) Sound Designer : </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.sound_designer}{" "}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="">(ix) Principal cast :</span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <span className="inputoffield">
                        {formData.principal_cast}
                      </span>
                      <span className="inputoffield"></span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </AccordionDetails>
      </Accordion>

            {/* Accordion for Document's */}
      <Accordion
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <button
            onClick={() => handleRedirectStep(5)}
            style={{
              background: "transparent",
              border: "none",
              marginRight: "20px",
              color: "#1c5768",
            }}
          >
            <BorderColorTwoToneIcon />
          </button>
          Documents
        </AccordionSummary>
        <AccordionDetails>
          <Container maxWidth="lg">
            <p className="m-0">
              <span className="titleoffield-view-out">
                8. Documents <span className="text-danger"> *</span>
              </span>
            </p>
            <div className="row">
              <div class="col-md-6">
                <p>
                  <span className="">(a) Schedule 1:</span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className=""></span>
                  <span className="inputoffield">
                    {" "}
                    {!formData?.documentData?.[9] ? (
                      <></>
                    ) : (
                      <span className="Attach_Photo_ID aline-item-right">
                        <a
                          href={`${GLOBAL_URL}downloadfile/ott/${formData.id}/${formData?.documentData?.[9].file}`}
                        >
                          <span>
                            <FileDownloadIcon />{" "}
                          </span>{" "}
                          {formData?.documentData?.[9].name}
                        </a>
                      </span>
                    )}
                  </span>{" "}
                </p>
              </div>

              <div class="col-md-6">
                <p>
                  <span className="">
                    (b) Synopsis of the Web Series (Precise, not exceeding 200
                    words):
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className=""></span>
                  <span className="inputoffield">
                    {formData?.synopsis}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="">
                    (c) Brief Profile of Creator(s) (Precise, not exceeding 200
                    words):
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className=""> </span>
                  <span className="inputoffield">
                    {" "}
                    {!formData?.documentData?.[2] ? (
                      <></>
                    ) : (
                      <span className="Attach_Photo_ID aline-item-right">
                        <a
                          href={`${GLOBAL_URL}downloadfile/ott/${formData.id}/${formData?.documentData?.[2].file}`}
                        >
                          <span>
                            <FileDownloadIcon />{" "}
                          </span>{" "}
                          {formData?.documentData?.[2].name}
                        </a>
                      </span>
                    )}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="">
                    (d) Brief Profile of Director(s) (Precise, not exceeding 200
                    words) :{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className=""> </span>
                  <span className="inputoffield">
                    {" "}
                    {!formData?.documentData?.[3] ? (
                      <></>
                    ) : (
                      <span className="Attach_Photo_ID aline-item-right">
                        <a
                          href={`${GLOBAL_URL}downloadfile/ott/${formData.id}/${formData?.documentData?.[3].file}`}
                        >
                          <span>
                            <FileDownloadIcon />{" "}
                          </span>{" "}
                          {formData?.documentData?.[3].name}
                        </a>
                      </span>
                    )}
                  </span>{" "}
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className="">
                    (e) Brief Profile of Producer(s) (Precise, not exceeding 200
                    words) :{" "}
                  </span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  <span className=""> </span>
                  <span className="inputoffield">
                    {" "}
                    {!formData?.documentData?.[4] ? (
                      <></>
                    ) : (
                      <span className="Attach_Photo_ID aline-item-right">
                        <a
                          href={`${GLOBAL_URL}downloadfile/ott/${formData.id}/${formData?.documentData?.[4].file}`}
                        >
                          <span>
                            <FileDownloadIcon />{" "}
                          </span>{" "}
                          {formData?.documentData?.[4].name}
                        </a>
                      </span>
                    )}
                  </span>{" "}
                </p>
              </div>
              <div className="col-md-12">
                <p className="mt-2">
                  <span className="text-danger">
                    NOTE: In case of multiple director(s), creator(s),
                    producer(s), their profile should be consolidated in one
                    document.
                  </span>
                </p>
              </div>
            </div>

            {/* Point 9 - Online Downloadable Digital File */}
            <p className="m-0 mt-4">
              <span className="titleoffield-view-out">
                9. Online streaming link (only vimeo or google Drive or similar platform links acceptable){" "}
                <span className="text-danger"> *</span>
              </span>
            </p>
            <div className="row">
              <div className="col-md-6">
                <p>
                  <span className="">(a) Online Link : </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">
                    <a href={`${formData?.online_link}`} target="_blank" rel="noopener noreferrer">
                      {formData?.online_link}
                    </a>
                  </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="">(b) Password (if any): </span>
                  <span className="inputoffield"></span>
                </p>
              </div>
              <div className="col-md-6">
                <p>
                  <span className="inputoffield">{formData?.online_password}</span>
                  <span className="inputoffield"></span>
                </p>
              </div>
            </div>
          </Container>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default Preview;
